import axios from 'axios';

//const dev = 'http://localhost:5000/';
const dev ='https://specific-lorain-automationandproduction-70d87699.koyeb.app/'


const Api = {
 
  login: async (dados) => {
    try {
      const response = await axios.post(dev + 'login', dados);
      //localStorage.setItem("token",JSON.stringify(response.data.token));
      localStorage.setItem("infoUser",JSON.stringify(response.data.userData));
      window.alert("Login efeituado com sucesso!!!");
      window.location.reload();
    } catch (error) {
      localStorage.clear();
      window.alert(error);
      console.error('Erro ao enviar dados para a API:', error.data.message);
      window.location.reload();
     
    }
  },
  cadastro: async (cadastro) => {
    try {
      await axios.post(dev + 'cadastro', cadastro);
      window.alert("Cadastro efetuado com sucesso!!!");
    } catch (error) {
      window.alert("Erro ao enviar dados para a API: " + error.response.data);
      console.error('Erro ao enviar dados para a API:', error.response.data);
    }
  },
  respostapesquisa: async (resposta) => {
    try {
      await axios.post(dev + 'respostapesquisa', resposta);
      window.alert("Resposta enviada com sucesso!!!");
    } catch (error) {
      window.alert("Erro ao enviar dados para a API: " + error.response.data);
      console.error('Erro ao enviar dados para a API:', error.response.data);
    }
  },
  historico: async () => {
    const infoUser = localStorage.getItem("infoUser");
    const userid = JSON.parse(infoUser);
    try {
      const response = await axios.post(dev + 'history',userid);
      return response.data;
      // console.log('Dados recebidos:', response.data);
    } catch (error) {
      window.alert("Erro ao ler os dados: " + error.response.data);
      console.error('Erro ao ler os dados:', error.response.data);
    }
  },
   respostapesquisa2: async (resposta) => {
    const infoUser = localStorage.getItem("infoUser");
    const user = JSON.parse(infoUser);

    const uploadcomp2 = {
      usuario_id: user.id,  
      respostas: resposta
    };
    try {
      await axios.post(dev + 'respostapesquisa2', uploadcomp2);
      window.alert("Resposta enviada com sucesso!!!");
    } catch (error) {
      window.alert("Erro ao enviar dados para a API: " + error.response.data);
      console.error('Erro ao enviar dados para a API:', error.response.data);
    }
  },

  forgotpassword: async (email) => {
  try {
    await axios.post(dev + 'forgot-password', {
      email: email
    });

    window.alert("Se o email existir, você receberá um link!");
  } catch (error) {
    window.alert("Erro ao enviar email: " + error.response?.data);
    console.error('Erro:', error.response?.data);
  }
  },
  resetPassword: async (token, senha) => {
    try {
      const res = await axios.post(dev + 'reset-password', {
        token: token,
        novaSenha: senha
      });

      window.alert(res.data.message);
    } catch (error) {
      window.alert("Erro ao redefinir senha: " + error.response?.data?.message);
      console.error("Erro:", error.response?.data);
    }
  }

};

export default Api;